export enum BetStopAttribute {
  Master = 839,
}
